import { FC, Key } from "react";

import { Flex } from "antd";

import DuplicateTransactions from "./DuplicateTransactions";
import GenerateTransactionPdf from "./GenerateTransactionPdf";
import NewTransaction from "./NewTransaction";
import RefreshAddress from "./RefreshAddress";
import Statistiques from "./Statistiques";
import Download from "./Download";
import UploadFaoPdf from "./UploadFaoPdf";

const TransactionFaoActions: FC<{
  selectedRowKeys: Key[];
  filters: Record<string, string[]>;
}> = ({ selectedRowKeys, filters }) => {
  const ids = selectedRowKeys.map((k) => k.toString());

  return (
    <Flex gap={16}>
      <DuplicateTransactions ids={ids} />
      <RefreshAddress ids={ids} />
      <GenerateTransactionPdf ids={ids} />
      <Statistiques filters={filters} />
      <Download
        filters={filters}
        collectionId="transactions_fao"
        endpoint="https://melcarnebackend.digipulse.ch/download_data"
        filename="transactions_fao.xlsx"
      />
      <Download
        filters={filters}
        collectionId="transactions_fao"
        endpoint="https://melcarnebackend.digipulse.ch/download_parcelles_unifiees"
        filename="parcelles_unifiees.xlsx"
        label="Exporter les parcelles unifiées"
      />
      <UploadFaoPdf />
      <NewTransaction />
    </Flex>
  );
};
export default TransactionFaoActions;
